'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var SmsActionIcon = require('@narvar/nth-bit-icon-sms-action');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var SMSOptInForm = require('./SMSOptInForm.js');
var OptInTemplate = require('../OptInTemplate.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var SmsActionIcon__default = /*#__PURE__*/_interopDefaultLegacy(SmsActionIcon);

const OptIn = ({
  featureName,
  layout,
  onOptIn,
  onChange,
  channel,
  validationError,
  notificationPreferencesState,
  consumerPreferencesOptinEnabled,
  retailerMarketingOptinEnabled
}) => {
  const {
    notificationCenterSmsOptinMessage
  } = nthHookTranslations.useTranslations();
  const smsOptInChannelProps = {
    optInChannelInput: /*#__PURE__*/React__default["default"].createElement(SMSOptInForm["default"], {
      onOptIn: onOptIn,
      onChange: onChange,
      validationError: validationError,
      layout: layout,
      featureName: featureName,
      notificationPreferencesState: notificationPreferencesState,
      consumerPreferencesOptinEnabled: consumerPreferencesOptinEnabled,
      retailerMarketingOptinEnabled: retailerMarketingOptinEnabled
    }),
    optInIcon: /*#__PURE__*/React__default["default"].createElement(SmsActionIcon__default["default"], {
      featureName: featureName
    }),
    optInMessageText: notificationCenterSmsOptinMessage || ''
  };
  return /*#__PURE__*/React__default["default"].createElement(OptInTemplate["default"], {
    featureName: featureName,
    layout: layout,
    channel: channel,
    optInChannelProps: smsOptInChannelProps,
    consumerPreferencesOptinEnabled: consumerPreferencesOptinEnabled
  });
};
var SmsOptIn = nthHookTranslations.withTranslationsProvider(OptIn, {
  translationKeys: ['notificationCenterSmsOptinMessage']
});

exports["default"] = SmsOptIn;
